import { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { AnamAvatarQuiz } from './AnamAvatarQuiz';
import { useQuizStore } from '../../hooks';

export const AnamAvatarQuizModal = ({ show, onHide }) => {
  const { isAllquestionsAnswered, isSessionClosed } = useQuizStore();

  useEffect(() => {
    if ((isAllquestionsAnswered || isSessionClosed) && show) {
      const timer = setTimeout(() => {
        onHide();
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [isAllquestionsAnswered, isSessionClosed, show, onHide]);

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered 
      size="lg"
      className="anam-avatar-quiz-modal"
      backdrop="static"
      keyboard={false}
      fullscreen="lg-down"
    >
      <Modal.Header closeButton>
        <Modal.Title>Encuesta con GoSafe Avatar</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ minHeight: '500px', padding: '1rem 1.5rem' }}>
        {show && <AnamAvatarQuiz />}
      </Modal.Body>
    </Modal>
  );
};
